import {Component, ContentChild, ElementRef, Input, OnInit, TemplateRef} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ReviewActionService} from '../../review-action-service';
import {ExcProgbarData} from '../../app-exc-progbar/app-exc-progbar.component';

@Component({
  selector: 'app-review-audit-item',
  templateUrl: './review-audit-item.component.html',
  styles: []
})
export class ReviewAuditItemComponent extends ExcTranslation implements OnInit {

  @Input('reviewItem') reviewItem: any;
  @ContentChild('sideMenu') sideMenuRef: TemplateRef<ElementRef>;
  @Input('smallItem') smallItem = false;
  constructor(private excDss: DefaultSettingsService, private excRas: ReviewActionService) {
    super();
  }
  ngOnInit() {
  }
  getProgbarData() {
    const x: ExcProgbarData[] = [];
    if (this.reviewItem.rvReviewOk) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewOk, this.getGlobal('ReviewedOk'), '#449d44', 'white', 'text', []));
    }
    if (this.reviewItem.rvReviewNOk) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewNOk, this.getGlobal('ReviewedOk'), '#F49306', 'white', 'text', []));
    }
    if (this.reviewItem.rvReviewCritical) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewCritical, this.getGlobal('ReviewedOk'), '#c9302c', 'white', 'text', []));
    }
    if (this.reviewItem.rvReviewNonFinal) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewNonFinal, this.getGlobal('ReviewedOk'), '#1b477f', 'white', 'text', []));
    }
    return x;
  }
  getProgbarData2() {
    const x: ExcProgbarData[] = [];
    if (this.reviewItem.rvReviewDone) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewDone, this.getGlobal('ReviewedOk'), '#449d44', 'white', 'text', []));
    }
    if (this.reviewItem.rvReviewOpen) {
      x.push(new ExcProgbarData(this.reviewItem.rvReviewOpen, this.getGlobal('ReviewedOk'), '#c9302c', 'white', 'text', []));
    }
    return x;
  }
  getSelfcheckTooltip() {
    const txt = 'Selfcheck';
    let add = '';
    if (this.reviewItem.AuditType === 35) {
      add = this.getGlobal('Documents');
    }
    if (this.reviewItem.AuditPartialResult === true) {
      if (add === '') {
        add = this.getGlobal('PartialResults');
      } else {
        add = add + ', ' + this.getGlobal('PartialResults');
      }
    }
    return txt + (add === '' ? '' : ' (' + add + ')');
  }
  getAvatarTooltip() {
    if (this.reviewItem.AuditIsGroup === true) {
      return this.getGlobal('GroupAudit');
    } else {
      if (this.reviewItem.IsLinked === true) {
        return this.getGlobal('LinkedAudits');
      } else {
        if (this.reviewItem.AuditType !== 16 && this.reviewItem.AuditType !== 35) {
          return this.getGlobal('Floorcheck');
        } else {
          return this.getSelfcheckTooltip();
        }
      }
    }
  }
  getAvatarClass() {
    if (this.reviewItem.AuditIsGroup === true) {
      return 'fa-users th-danger ch-both';
    } else if (this.reviewItem.IsLinked === true) {
      return 'fa-link th-warning ch-both';
    } else {
      if (this.reviewItem.AuditType === 16) {
        if (this.reviewItem.AuditPartialResult === true) {
          return 'fa-mobile th-danger';
        } else {
          return this.reviewItem.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary';
        }
      } else if (this.reviewItem.AuditType === 35) {
        if (this.reviewItem.AuditPartialResult === true) {
          return 'fa-scanner-image th-danger';
        } else {
          return this.reviewItem.AuditIsPicked ? 'fa-scanner-image th-warning' : 'fa-scanner-image th-secondary';
        }
      } else {
        return this.reviewItem.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
      }
    }
  }
  getLinkedAudits() {
    let msg = '';
    if (this.reviewItem && this.reviewItem.Infoline3 && this.reviewItem.Infoline3 !== null) {
      const audits = this.reviewItem.Infoline3.split(',');
      for (let i = 0; i < audits.length; i++) {
        const pt = audits[i].split('|');
        if (i > 0) {
          msg += ' - ';
        }
        msg += this.getGlobal('AuditType_' + pt[0]);
        if (pt[1] === '1') {
          msg += ' (Picked)';
        }
      }
    }
    return msg;
  }
}
